<template>
  <pf-empty-state v-if="loading">
    <pf-empty-state-header :title="$t('Caricamento delle chiavi in corso...')" heading-level="h4">
      <template #icon>
        <pf-empty-state-icon>
          <pf-spinner />
        </pf-empty-state-icon>
      </template>
    </pf-empty-state-header>
  </pf-empty-state>

  <x-form
    v-else
    :prevent-submit="!newKey"
    style="max-width: 800px;"
    :submit-text="$t('Carica')"
    @submit="uploadKey"
    class="pf-v6-u-mb-lg"
  >
    <form-group :name="$t('Aggiungi una chiave SSH')" required>
      <pf-textarea v-model="newKey" name="ssh_key" placeholder="Chiave pubblica in formato OpenSSH" style="width: 100%; height:125px" />
    </form-group>
  </x-form>

  <pf-title h="3">{{ $t('Chiavi SSH associate al tuo account') }}</pf-title>
    <pf-empty-state v-if="!keys.length">
      <pf-empty-state-header :title="$t('Nessuna chiave presente')" heading-level="h4" />
    </pf-empty-state>

    <pf-simple-list v-else>
      <pf-simple-list-item v-for="k in keys" :key="k" >
        <key-icon />
        {{ k }}
        <pf-button small variant="danger" @click="remove(k)">
          <template #icon><trash-icon /></template>
        </pf-button>
      </pf-simple-list-item>
    </pf-simple-list>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { SSHKeysResource } from '@/resources';
import TrashIcon from '@vue-patternfly/icons/trash-icon';
import KeyIcon from '@vue-patternfly/icons/key-icon';

const props = defineProps<{
  idPannello: number;
}>();

const loading = ref(false);
const keys = ref([] as string[]);
const newKey = ref('');

const loadkeys = async() => {
  loading.value = true;
  try {
    keys.value = await new SSHKeysResource({idPannello: props.idPannello}).get();
  } finally {
    loading.value = false;
  }
};

async function remove(k: string) {
  await new SSHKeysResource({idPannello: props.idPannello}).delete(encodeURIComponent(k));
  loadkeys();
}

async function uploadKey() {
  if (newKey.value && confirm('Vuoi caricare questa chiave SSH sul pannello?')) {
    const data = new FormData();
    data.append('idPannello', String(props.idPannello));
    data.append('key', newKey.value);
    await new SSHKeysResource().save(data);
    newKey.value = '';
    loadkeys();
  }
}

onMounted(() => {
  loadkeys();
});
</script>
